import React from 'react';
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { useTranslation } from "@/hooks/useTranslation";

const DisclaimerModal = ({ onAccept }) => {
  const { t } = useTranslation();

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/90 backdrop-blur-sm">
      <Card className="glass-card border-2 border-[#F4C430] max-w-2xl w-full animate-fade-in">
        <CardHeader className="text-center">
          <CardTitle 
            className="text-2xl sm:text-3xl text-white mb-4" 
            style={{ fontFamily: 'Cinzel, serif' }}
          >
            {t('disclaimer_title')}
          </CardTitle>
        </CardHeader>
        <CardContent className="space-y-6">
          <div className="bg-white/5 rounded-lg p-6 border border-[#F4C430]/30">
            <p className="text-white/90 text-base sm:text-lg leading-relaxed text-center">
              {t('disclaimer_text')}
            </p>
          </div>
          
          <Button
            onClick={onAccept}
            className="w-full bg-gradient-to-r from-[#D4AF37] to-[#F4C430] hover:from-[#F4C430] hover:to-[#D4AF37] text-[#0a2e38] font-semibold py-6 text-lg"
            style={{ fontFamily: 'Cinzel, serif' }}
          >
            {t('disclaimer_accept')}
          </Button>
          
          <p className="text-white/60 text-xs text-center italic">
            ELUA • Résonne Juste. Résonne Toi.
          </p>
        </CardContent>
      </Card>
    </div>
  );
};

export default DisclaimerModal;
